<script setup lang="ts">
import { useRouter } from "vue-router";
import type { Portfolio } from "~/typings/portfolio";
import ExperienceCard from "~/components/ui/ExperienceCard/index.vue";

type Props = {
  experiences: Portfolio.Experience[];
};

const DISPLAY_COUNT = 3;
const props = defineProps<Props>();
const router = useRouter();
const visibleExperiences = props.experiences.filter((exp) => exp.visible);
const lastThreeExperiences = visibleExperiences.slice(0, DISPLAY_COUNT);

const navigateToProject = (id: string) => {
  router.push(`/projects/${id}`);
};
</script>
<template>
  <div>
    <ul class="space-y-6" aria-label="Recent work experience">
      <li v-for="exp in lastThreeExperiences" :key="exp.id">
        <ExperienceCard
          v-bind="{ ...exp, technologies: exp.technologies.slice(0, 5) }"
          @click="navigateToProject(exp.id)"
        />
      </li>
    </ul>
    <div class="my-8 block lg:hidden">
      <UiButton
        variant="solid"
        size="md"
        class="mt-4 w-full text-center"
        href="/projects"
        aria-label="View detailed projects page"
      >
        <span class="w-full">View all my projects</span>
      </UiButton>
    </div>
  </div>
</template>
